const DEFAULT_DO_GOOGLE_REVIEW_REDIRECT_SECONDS = 30;

function parsePositiveInt(value: string | undefined, fallback: number): number {
  if (!value) return fallback;
  const n = Number(value);
  if (!Number.isFinite(n)) return fallback;
  if (n <= 0) return fallback;
  return Math.floor(n);
}

export const DO_GOOGLE_REVIEW_REDIRECT_SECONDS = parsePositiveInt(
  process.env.REACT_APP_DO_GOOGLE_REVIEW_REDIRECT_SECONDS,
  DEFAULT_DO_GOOGLE_REVIEW_REDIRECT_SECONDS
);


